import axios from "axios";

export async function fetchCalendarExceptions(companyKey, from, to) {
  const res = await axios.get("/api/calendarexceptions", {
    params: { companyKey, from, to },
  });
  return res.data; 
}

export async function createCalendarException(companyKey, payload) {
  const res = await axios.post("/api/calendarexceptions", payload, {
    params: { companyKey },
  });
  return res.data;
}

export async function updateCalendarException(id, payload) {
  const res = await axios.put(`/api/calendarexceptions/${id}`, payload);
  return res.data;
}

export async function deleteCalendarException(id) {
  await axios.delete(`/api/calendarexceptions/${id}`);
}

export async function bulkUpsertCalendarExceptions(companyKey, items) {
  const res = await axios.post("/api/calendarexceptions/bulk-upsert", { items }, {
    params: { companyKey },
  });
  return res.data;
}